import { Http } from '../../shared';

export class LocaleService {
    constructor() {
        this.http = new Http();
    }

    async search() {
        var result = {
            data: [{ locale: 'en-US', language: "English" }, { locale: 'nb-NO', language: "Norsk" }],
            page_size: 100,
            page_number: 1,
            total_size: 2,
        };
        return result;
    }

}